(function() {
  // Helper function to get selected size from variant selector (reusable)
  function getSelectedSizeFromVariantSelector(variantSelects) {
    if (!variantSelects) return null;
    
    var selectedSize = null;
    
    // 1) Check checked radio button
    var radio = variantSelects.querySelector('input[type="radio"][name*="Size" i]:checked, input[type="radio"][name*="size" i]:checked');
    if (radio && radio.value) {
      return radio.value.trim();
    }
    
    // 2) Check selected option in select dropdown
    var select = variantSelects.querySelector('select[name^="options"][name*="size" i], select[name*="Size" i]');
    if (select && select.selectedOptions && select.selectedOptions[0] && select.selectedOptions[0].value) {
      return select.selectedOptions[0].value.trim();
    }
    
    // 3) Check script tag with selected variant JSON
    var selectedJsonEl = variantSelects.querySelector('script[data-selected-variant]');
    if (selectedJsonEl && selectedJsonEl.textContent) {
      try {
        var selected = JSON.parse(selectedJsonEl.textContent);
        var optionInputs = Array.from(variantSelects.querySelectorAll('.product-form__input'));
        for (var i = 0; i < optionInputs.length; i++) {
          var inputLabel = optionInputs[i].querySelector('label, legend');
          if (inputLabel && inputLabel.textContent.toLowerCase().includes('size')) {
            if (i === 0 && selected.option1) {
              return selected.option1;
            } else if (i === 1 && selected.option2) {
              return selected.option2;
            } else if (i === 2 && selected.option3) {
              return selected.option3;
            }
            break;
          }
        }
      } catch(e) {
        // Silently fail if JSON parse fails
      }
    }
    
    return null;
  }

  // Helper function to extract size from variant object
  function extractSizeFromVariant(variant, variantSelects) {
    if (!variant || !variantSelects) return null;
    
    var optionInputs = Array.from(variantSelects.querySelectorAll('.product-form__input'));
    for (var i = 0; i < optionInputs.length; i++) {
      var inputLabel = optionInputs[i].querySelector('label, legend');
      if (inputLabel && inputLabel.textContent.toLowerCase().includes('size')) {
        if (i === 0 && variant.option1) {
          return variant.option1;
        } else if (i === 1 && variant.option2) {
          return variant.option2;
        } else if (i === 2 && variant.option3) {
          return variant.option3;
        }
        break;
      }
    }
    return null;
  }

  function setupInlineCalculator(root) {
    if (!root || !root.classList || !root.classList.contains('bra-inline-size-guide')) return;
    var calc = root.querySelector('#calculatorOptions');
    if (!calc) return;

    var bandOptions = [];
    var cupOptions = [];
    var mapping = {};
    try { bandOptions = JSON.parse(calc.getAttribute('data-band-options') || '[]'); } catch(e) {}
    try { cupOptions = JSON.parse(calc.getAttribute('data-cup-options') || '[]'); } catch(e) {}
    var mappingScript = calc.querySelector('.bra-inline-mapping');
    if (mappingScript && mappingScript.textContent) {
      try { mapping = JSON.parse(mappingScript.textContent); } catch(e) { mapping = {}; }
    }

    var bandSelect = calc.querySelector('select[data-type="band"]');
    var cupSelect = calc.querySelector('select[data-type="cup"]');
    var sizeSelect = calc.querySelector('select[data-type="size"]');
    var refListEl = root.querySelector('[data-ref-list]');
    var refSizeEl = root.querySelector('[data-ref-size]');
    var refContainer = root.querySelector('.bra-inline-size-reference');
    var labelSizeEl = root.querySelector('.bra-inline-label-strong');

    if (!bandSelect || !cupSelect || !sizeSelect || !refListEl) return;

    // Build unique alpha sizes list from mapping
    var alphaSet = new Set();
    Object.keys(mapping || {}).forEach(function(cup){
      var row = mapping[cup] || {};
      Object.keys(row).forEach(function(band){
        var a = row[band]; if (a) alphaSet.add(a);
      });
    });
    var alphaSizes = Array.from(alphaSet);

    // Populate size dropdown with alpha sizes and enable it
    (function initSizeSelect(){
      var opts = ['<option value="">Size</option>'].concat(
        alphaSizes.map(function(a){ return '<option value="' + a + '">' + a + '</option>'; })
      );
      sizeSelect.innerHTML = opts.join('');
      sizeSelect.disabled = false;
    })();

    function computeSize(band, cup) {
      if (!band || !cup) return '';
      if (!mapping[cup]) return '';
      return mapping[cup][band] || '';
    }

    function listFitsForAlpha(alpha) {
      if (!alpha) return '';
      var pairs = [];
      (cupOptions || []).forEach(function(cup) {
        var row = mapping[cup] || {};
        (bandOptions || []).forEach(function(band) {
          if (row[band] === alpha) {
            pairs.push(band + cup);
          }
        });
      });
      return pairs.join(', ');
    }

    function updateFromBandCup() {
      var band = bandSelect.value;
      var cup = cupSelect.value;
      var size = computeSize(band, cup);
      if (size) {
        sizeSelect.value = size;
        applySizeToMainPicker(size);
      }
      if (size) {
        refListEl.textContent = listFitsForAlpha(size);
        if (refSizeEl) refSizeEl.textContent = size;
        if (refContainer) refContainer.removeAttribute('data-empty');
      } else {
        refListEl.textContent = '';
        if (refSizeEl) refSizeEl.textContent = '—';
        if (refContainer) refContainer.setAttribute('data-empty', 'true');
      }
      if (labelSizeEl) {
        labelSizeEl.textContent = size || 'Select your band and cup';
      }
    }

    function updateFromAlpha() {
      var size = sizeSelect.value || '';
      if (size) {
        refListEl.textContent = listFitsForAlpha(size);
        if (refSizeEl) refSizeEl.textContent = size;
        if (refContainer) refContainer.removeAttribute('data-empty');
      } else {
        refListEl.textContent = '';
        if (refSizeEl) refSizeEl.textContent = '—';
        if (refContainer) refContainer.setAttribute('data-empty', 'true');
      }
      if (labelSizeEl) {
        labelSizeEl.textContent = size || 'Select your band and cup';
      }
      if (size) {
        applySizeToMainPicker(size);
      }
    }

    bandSelect.addEventListener('change', updateFromBandCup);
    cupSelect.addEventListener('change', updateFromBandCup);
    sizeSelect.addEventListener('change', updateFromAlpha);
    
    // Listen to main Size picker changes and sync to inline calculator
    syncFromMainPicker(sizeSelect, labelSizeEl, listFitsForAlpha, refListEl, refSizeEl, refContainer);
    
    // Initial paint: pre-select first available variant size
    function initializeFromSelectedVariant() {
      function tryInitialize() {
        var variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) {
          if (refContainer) refContainer.setAttribute('data-empty', 'true');
          updateFromBandCup();
          return;
        }
        
        // Get selected size using reusable helper function
        var selectedSize = getSelectedSizeFromVariantSelector(variantSelects);
        
        // If we found a selected size, pre-select it in the calculator
        if (selectedSize) {
          var normalizedSize = selectedSize.trim().toLowerCase();
          var matchingAlpha = alphaSizes.find(function(a) {
            return a.toString().trim().toLowerCase() === normalizedSize;
          });
          
          if (matchingAlpha) {
            sizeSelect.value = matchingAlpha;
            updateFromAlpha();
            return;
          }
        }
        
        // No size found or size doesn't match - set empty state
        if (refContainer) refContainer.setAttribute('data-empty', 'true');
        updateFromBandCup();
      }
      
      // Try immediately, then retry after a short delay if variant selector might not be ready
      tryInitialize();
      
      // Retry after a short delay to handle cases where variant selector loads after calculator
      setTimeout(function() {
        if (sizeSelect.value === '') {
          tryInitialize();
        }
      }, 100);
    }
    
    // Initialize on page load
    initializeFromSelectedVariant();
  }
  
  function syncFromMainPicker(sizeSelect, labelSizeEl, listFitsForAlphaFn, refListEl, refSizeEl, refContainer) {
    var variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    
    // Helper function to update inline calculator
    function updateInlineCalculator(selectedSize) {
      if (!selectedSize || !sizeSelect) return;
      
      // Update the inline calculator's size dropdown
      sizeSelect.value = selectedSize;
      
      // Update the label
      if (labelSizeEl) {
        labelSizeEl.textContent = selectedSize;
      }
      
      // Trigger visual update (but don't trigger applySizeToMainPicker to avoid loop)
      if (refListEl && refSizeEl && refContainer) {
        refListEl.textContent = listFitsForAlphaFn(selectedSize);
        refSizeEl.textContent = selectedSize;
        refContainer.removeAttribute('data-empty');
      }
    }
    
    // Use the same pattern as component-card-product-list.js setupMainProductSizeListener
    variantSelects.addEventListener('change', function(e) {
      var target = e.target;
      
      // Check if this is from a complementary product (skip those)
      if (target.closest && target.closest('.complementary-product-card')) return;
      
      // Check if this is a size input change (same logic as component-card-product-list.js)
      var sizeInput = target.closest('.product-form__input');
      if (!sizeInput) return;
      
      var label = sizeInput.querySelector('label, legend');
      if (!label || !label.textContent.toLowerCase().includes('size')) return;
      
      // Get the selected size value (same logic as component-card-product-list.js)
      var selectedSize = null;
      
      if (target.type === 'radio' && target.checked) {
        selectedSize = target.value;
      } else if (target.tagName === 'SELECT' && target.value) {
        selectedSize = target.value;
      }
      
      if (selectedSize) {
        updateInlineCalculator(selectedSize);
      }
    });
    
    // Also listen to pubsub events for variant changes (same as component-card-product-list.js)
    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function(event) {
        if (!event || !event.data) return;
        
        var variant = event.data.variant;
        if (!variant) return;
        
        // Extract size from variant using reusable helper function
        var selectedSize = extractSizeFromVariant(variant, variantSelects);
        
        if (selectedSize) {
          updateInlineCalculator(selectedSize);
        }
      });
    }
  }

  function applySizeToMainPicker(sizeText) {
    if (!sizeText) return;
    
    // Update main product variant picker (variant-selects element)
    updateMainProductVariantPicker(sizeText);
    
    // Update complementary product cards (product-card-size-select dropdowns)
    updateComplementaryProductCards(sizeText);
  }

  function updateMainProductVariantPicker(sizeText) {
    if (!sizeText) return;
    
    var normalizedSize = sizeText.trim().toLowerCase();
    var variantSelects = document.querySelector('variant-selects');
    
    if (!variantSelects) return;
    
    // 1) Try radios labeled as Size (common for button-style pickers)
    var radio = variantSelects.querySelector('input[type="radio"][name*="Size" i][value="' + cssEscape(sizeText) + '"]')
      || Array.from(variantSelects.querySelectorAll('input[type="radio"][name*="Size" i]')).find(function(r){
        return (r.value || '').toString().trim().toLowerCase() === normalizedSize;
      });
    
    if (radio && !radio.checked) {
      radio.checked = true;
      
      // Mark the option as selected in the DOM
      var selectedOption = radio.closest('.product-form__input').querySelector('input[data-option-value-id]');
      if (selectedOption) {
        // Remove selected attribute from all options in this group
        var allOptions = variantSelects.querySelectorAll('input[name="' + radio.name + '"][data-option-value-id]');
        allOptions.forEach(function(opt) {
          opt.removeAttribute('selected');
        });
        // Set selected on the chosen option
        radio.setAttribute('selected', 'selected');
      }
      
      // Trigger the change event on the radio button
      // The product-info component will handle fetching and updating the variant ID
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      
      return;
    }

    // 2) Try selects named options[Size] (dropdown-style pickers)
    var select = variantSelects.querySelector('select[name^="options"][name*="size" i], select[name*="Size" i]');
    if (select) {
      var matchOption = Array.from(select.options).find(function(opt){
        return (opt.value || '').toString().trim().toLowerCase() === normalizedSize;
      });
      if (matchOption) {
        // Remove selected from all options
        Array.from(select.options).forEach(function(opt) {
          opt.removeAttribute('selected');
        });
        
        // Set the value and mark as selected
        select.value = matchOption.value;
        matchOption.setAttribute('selected', 'selected');
        
        // Trigger change event
        // The product-info component will handle fetching and updating the variant ID
        select.dispatchEvent(new Event('change', { bubbles: true }));
        
        return;
      }
    }
  }

  // NOTE: This function is no longer needed as the product-info component
  // automatically handles variant ID updates when the change event fires.
  // Keeping it here for reference but it should not be called.
  // 
  // The issue was that this function read the OLD variant from [data-selected-variant]
  // before the product-info component could fetch and update it with the NEW variant.
  function updateProductFormVariantId(variantSelects) {
    // DEPRECATED: Do not use this function
    // The product-info component handles variant updates automatically
    return;
  }

  function updateComplementaryProductCards(sizeText) {
    if (!sizeText) return;
    
    var normalizedSize = sizeText.trim().toLowerCase();
    
    // Find all complementary product cards (used in product page and cart drawer)
    var productCards = document.querySelectorAll('.complementary-product-card, .cart-drawer-product-card');
    
    productCards.forEach(function(card) {
      var sizeSelector = card.querySelector('.product-card-size-selector');
      if (!sizeSelector) return;
      
      var sizeSelect = sizeSelector.querySelector('.product-card-size-select');
      if (!sizeSelect) return;
      
      // Find matching size option (case-insensitive)
      var options = Array.from(sizeSelect.options);
      var matchingOption = options.find(function(option) {
        var value = option.value;
        return value && value.trim().toLowerCase() === normalizedSize;
      });
      
      if (matchingOption) {
        var value = matchingOption.value;
        var variantId = matchingOption.dataset.variantId;
        
        if (value && variantId) {
          // Set the select value
          sizeSelect.value = value;
          
          // Trigger change event to update the form
          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Update hidden variant ID input
          var productId = sizeSelector.dataset.productId;
          var variantInput = card.querySelector('.product-variant-id[data-product-id="' + productId + '"]');
          
          if (variantInput) {
            variantInput.value = variantId;
          }
          
          // Enable the add-to-cart button
          var atcButton = card.querySelector('.product-card__atc');
          if (atcButton) {
            atcButton.disabled = false;
            atcButton.removeAttribute('aria-disabled');
          }
        }
      }
    });
  }

  function cssEscape(str) {
    try { return CSS && CSS.escape ? CSS.escape(str) : str.replace(/"/g, '\\"'); } catch(e) { return str; }
  }

  function initAllInlineCalculators() {
    document.querySelectorAll('.bra-inline-size-guide').forEach(setupInlineCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInlineCalculators);
  } else {
    initAllInlineCalculators();
  }
})();
